const PREFIXO = "relato_wizard_v1:";
const TTL_MS = 12 * 60 * 60 * 1000; // 12h (guarda contra dado velho)

export const WIZARD_STORAGE_PREFIXO = PREFIXO;

function storageSeguro() {
  try {
    if (typeof sessionStorage === "undefined") return null;
    return sessionStorage;
  } catch (_e) {
    return null;
  }
}

/**
 * @typedef {{ formularios: Array<Object>, indiceEdicao: number|null, alterado?: boolean }|null} RascunhoTerceiros
 */

/**
 * @param {string} contexto
 * @returns {{ passoDados: number, passoTerceiros: number, sq: *, modoFormularioTerceiros: boolean, terceirosDraft: RascunhoTerceiros, rascunhoNovo: Object|null }|null}
 */
export function carregarPassosWizard(contexto) {
  const storage = storageSeguro();
  if (!storage || !contexto) return null;
  try {
    const raw = storage.getItem(PREFIXO + contexto);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.timestamp && Date.now() - parsed.timestamp > TTL_MS) {
      storage.removeItem(PREFIXO + contexto);
      return null;
    }
    const draft = parsed.terceirosDraft;
    return {
      passoDados: Number.isFinite(Number(parsed.passoDados))
        ? Number(parsed.passoDados)
        : 0,
      passoTerceiros: Number.isFinite(Number(parsed.passoTerceiros))
        ? Number(parsed.passoTerceiros)
        : 0,
      sq: parsed.sq ?? null,
      modoFormularioTerceiros: parsed.modoFormularioTerceiros === true,
      terceirosDraft:
        draft && Array.isArray(draft.formularios) && draft.formularios.length
          ? {
              formularios: draft.formularios,
              indiceEdicao:
                typeof draft.indiceEdicao === "number"
                  ? draft.indiceEdicao
                  : null,
              ...(typeof draft.alterado === "boolean"
                ? { alterado: draft.alterado }
                : {})
            }
          : null,
      rascunhoNovo:
        parsed.rascunhoNovo && typeof parsed.rascunhoNovo === "object"
          ? parsed.rascunhoNovo
          : null
    };
  } catch (_e) {
    return null;
  }
}

/**
 * @param {string} contexto
 * @param {{ passoDados?: number, passoTerceiros?: number, sq?: *, modoFormularioTerceiros?: boolean, terceirosDraft?: RascunhoTerceiros, rascunhoNovo?: Object|null }} estado
 */
export function salvarPassosWizard(contexto, estado) {
  const storage = storageSeguro();
  if (!storage || !contexto) return;
  try {
    storage.setItem(
      PREFIXO + contexto,
      JSON.stringify({
        passoDados: estado?.passoDados || 0,
        passoTerceiros: estado?.passoTerceiros || 0,
        sq: estado?.sq ?? null,
        modoFormularioTerceiros: estado?.modoFormularioTerceiros === true,
        terceirosDraft: estado?.terceirosDraft ?? null,
        rascunhoNovo: estado?.rascunhoNovo ?? null,
        timestamp: Date.now()
      })
    );
  } catch (_e) {
    return;
  }
}

/**
 * @param {string} contexto
 */
export function limparPassosWizard(contexto) {
  const storage = storageSeguro();
  if (!storage || !contexto) return;
  try {
    storage.removeItem(PREFIXO + contexto);
  } catch (_e) {
    return;
  }
}

const PREFIXO_ABA = "relato_wizard_aba_v1:";

export const WIZARD_ABA_STORAGE_PREFIXO = PREFIXO_ABA;

/**
 * @param {string} contexto
 * @returns {{ aba: string|null, sq: * }|null}
 */
export function carregarAbaWizard(contexto) {
  const storage = storageSeguro();
  if (!storage || !contexto) return null;
  try {
    const raw = storage.getItem(PREFIXO_ABA + contexto);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.timestamp && Date.now() - parsed.timestamp > TTL_MS) {
      storage.removeItem(PREFIXO_ABA + contexto);
      return null;
    }
    return {
      aba: typeof parsed.aba === "string" ? parsed.aba : null,
      sq: parsed.sq ?? null
    };
  } catch (_e) {
    return null;
  }
}

/**
 * @param {string} contexto
 * @param {{ aba?: string|null, sq?: * }} estado
 */
export function salvarAbaWizard(contexto, estado) {
  const storage = storageSeguro();
  if (!storage || !contexto) return;
  try {
    storage.setItem(
      PREFIXO_ABA + contexto,
      JSON.stringify({
        aba: estado?.aba ?? null,
        sq: estado?.sq ?? null,
        timestamp: Date.now()
      })
    );
  } catch (_e) {
    return;
  }
}

/**
 * @param {string} contexto
 */
export function limparAbaWizard(contexto) {
  const storage = storageSeguro();
  if (!storage || !contexto) return;
  try {
    storage.removeItem(PREFIXO_ABA + contexto);
  } catch (_e) {
    return;
  }
}
